import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Dialog,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Button,
  Menu,
  Divider,
  Autocomplete,
  TextField,
  Skeleton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Styles from "../Dashboard.module.scss";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ActiveProjects from "../../../assets/images/active_projects.svg";
import TotalTask from "../../../assets/images/total_task.svg";
import TotalInProgress from "../../../assets/images/TotalInProgress.svg";
import TotalCompleted from "../../../assets/images/TotalCompleted.svg";
import TotalProduction from "../../../assets/images/TotalProduction.svg";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Active_Projects from "../../../assets/images/Dashboard/Active_Projects.png";
import Total_Completed from "../../../assets/images/Dashboard/Total_Completed.png";
import Total_Production from "../../../assets/images/Dashboard/Total_Production.png";
import Total_Progress from "../../../assets/images/Dashboard/Total_Progress.png";
import Total_Task from "../../../assets/images/Dashboard/Total_Task.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Mousewheel, Autoplay } from "swiper/modules";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";

import PublicHoliday_NoData from "../../../assets/images/Public_Holiday_NoData.svg";
import Employee_Celebration_NoData from "../../../assets/images/Employee_Celebration_NoData.svg";
import Employee_Absence_NoData from "../../../assets/images/Employee_Absence_NoData.svg";
import Production_NoData from "../../../assets/images/Production_NoData.svg";
import AppDownloadCard from "./AppDownloadCard";
import TaskOverviewTable from "./TaskOverviewTable";
import dayjs from "dayjs";
import { getTaskOverview } from "../../../services/dashboard.service";
import { encryptData } from "../../../utils/cryptoUtils";

const EmployeeDashboard = ({
  data,
  handleEdit,

  handleChangePassword,
  renderFile,
  employeeProject,
  selectedProject,
  setSelectedProject,
  emgName,
  emgRelation,
  emgMobile,
  doorNo_street,
  place,
  district,
  pincode,
  annualAvaLeave,
  sickAvaLeave,
  unPaidAvaLeave,
  annualTakenLeave,
  sickTakenLeave,
  unPaidTakenLeave,
  employeeDepartment,
  employeeRole,
  employeeStatus,
  employeeType,
  adminData,
  handleDateChange,
  handleMenuClick,
  handleMenuClose,
  isMenuOpen,
  anchorEl,
  selectedDate,
  who,
  productionStatus,
  allHolidays,
}) => {
  const navigate = useNavigate();
  const projectTasks =
    (Array.isArray(data?.projectTask) && data.projectTask) ||
    (Array.isArray(adminData?.projectTasks) && adminData.projectTasks) ||
    [];
  const recentProductionUpdate =
    (Array.isArray(data?.recentProductionUpdate) &&
      data.recentProductionUpdate) ||
    (Array.isArray(adminData?.recentProductionUpdate) &&
      adminData.recentProductionUpdate) ||
    [];
  const upcomingCelebrations =
    (Array.isArray(data?.upcomingCelebrations) &&
      data.upcomingCelebrations) ||
    (Array.isArray(adminData?.upcomingCelebrations) &&
      adminData.upcomingCelebrations) ||
    [];
  const publicHolidayData =
    (Array.isArray(data?.publicHoliday) && data.publicHoliday) ||
    (Array.isArray(adminData?.publicHoliday) && adminData.publicHoliday) ||
    [];
  const futureLeavesGrouped2 =
    (Array.isArray(data?.futureLeavesGrouped2) && data.futureLeavesGrouped2) ||
    (Array.isArray(adminData?.futureLeavesGrouped2) && adminData.futureLeavesGrouped2) ||
    [];

  // Calendar state management
  const [calendarSelectedDate, setCalendarSelectedDate] = useState(dayjs());
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [allCalendarData, setAllCalendarData] = useState([]);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);
  const [taskOverviewData, setTaskOverviewData] = useState([]);

  // Fetch Task Overview Data
  useEffect(() => {
    const fetchTaskOverview = async () => {
      setIsEmployeeLoading(true);
      try {
        const month = encryptData((selectedDate.month() + 1).toString());
        const year = encryptData(selectedDate.year().toString());
        const response = await getTaskOverview({ month, year });
        if (response?.data?.data) {
          setTaskOverviewData(response.data.data);
        } else {
          setTaskOverviewData([]);
        }
      } catch (error) {
        console.error("Error fetching task overview:", error);
        setTaskOverviewData([]);
      } finally {
        setIsEmployeeLoading(false);
      }
    };
    fetchTaskOverview();
  }, [selectedDate]);

  // Fetch all calendar data once on mount
  useEffect(() => {
    if (allHolidays && allHolidays.length > 0) {
      const sortedHolidays = [...allHolidays].sort((a, b) => new Date(a.date) - new Date(b.date));
      setAllCalendarData(sortedHolidays);
    } else if (publicHolidayData) {
      const sortedHolidays = [...publicHolidayData].sort((a, b) => new Date(a.date) - new Date(b.date));
      setAllCalendarData(sortedHolidays);
    }
  }, [allHolidays, publicHolidayData]);

  // Helper function for date suffix
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };


  const employeeConfig = [
    {
      img: ActiveProjects,
      title: "Active Projects",
      value: `${data?.project?.filter((project) => project.isEnabled === true && project.isActive === true).length || 0}`,
      color: "#EBF5FF",
      borderColor: "#2B6AB1",
      SubBoxColor: "#C5DEF8",
      SubBoxImage: Active_Projects,
    },
    {
      img: TotalTask,
      title: "Total Tasks",
      value: `${data.totaltask || 0}`,
      color: "#F4EDFF",
      borderColor: "#573AA8",
      SubBoxColor: "#DECDF9",
      SubBoxImage: Total_Task,
    },
    {
      img: TotalInProgress,
      title: "Total In Progress",
      value: `${data.totalInProgress || 0}`,
      color: "#E8FFF9",
      borderColor: "#327B68",
      SubBoxColor: "#C1F3E6",
      SubBoxImage: Total_Production,
    },
    {
      img: TotalCompleted,
      title: "Total Completed",
      value: `${data.totalCompleted || 0}`,
      color: "#F1FFEB",
      borderColor: "#21A600",
      SubBoxColor: "#D6F5C9",
      SubBoxImage: Total_Progress,
    },
    {
      img: TotalProduction,
      title: "Total Production",
      value: `${data.totalProduction || 0}`,
      color: "#FFF7EC",
      borderColor: "#FFB657",
      SubBoxColor: "#FFEBCF",
      SubBoxImage: Total_Completed,
    },
  ];

  const ProgressItem = ({ label, value }) => (
    <Box
      sx={{
        textAlign: "center",
        mx: "auto",
        py: 1,
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 2, fontSize: "14px" }}>
        {label}
      </Typography>
      <Box sx={{ position: "relative", display: "inline-flex", padding: 0 }}>
        {/* Background Circle */}
        <CircularProgress
          variant="determinate"
          value={100} // Full circle
          size={125} // Medium size
          thickness={5}
          sx={{ color: "#F5F5F5", position: "absolute" }}
        />
        {/* Foreground Circle */}
        <CircularProgress
          variant="determinate"
          value={value}
          size={125} // Medium size
          thickness={5}
          sx={{ color: "#008080" }} // Foreground color
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" component="div">
            {`${value}%`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Grid container spacing={{ xs: 1, md: 2 }}>
        {/* Project Analytics Section */}
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
          }}
        >
          <Box className={Styles.MainCard}>
            <Typography variant="h6" className={Styles.HeaderTitle}>
              Project Analytics
            </Typography>
            <Grid container mt={2} spacing={2}>
              {employeeConfig.map((item, index) => (
                <Grid
                  size={{
                    xs: index === 4 ? 12 : 6,
                    sm: 6,
                    md: 2.4,
                    lg: 2.4,
                  }}
                  key={index}
                >
                  <Card
                    className={Styles.CardDesign}
                    style={{
                      backgroundColor: item.color,
                      "--border-color": item.borderColor,
                    }}
                  >
                    <Stack
                      direction={"row"}
                      width={"100%"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      padding={"0px 12px 0px 18px"}
                    >
                      <Stack spacing={0.5}>
                        <Typography
                          variant="subtitle1"
                          className={Styles.Title}
                        >
                          {item.title}
                        </Typography>
                        <Typography variant="h4" className={Styles.Value}>
                          {item.value}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{
                          background: item.SubBoxColor,
                          padding: "5px",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={item.SubBoxImage}
                          alt="LMT-Logo"
                          style={{
                            height: "25px",
                            width: "25px",
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Left Section - 8 Columns */}
        <Grid
          size={{ xs: 12, sm: 12, md: 7, lg: 8 }}
          sx={{
            width: "100%",
            overflow: { xs: "visible", md: "scroll" },
            height: { xs: "auto", md: "calc(100vh - 170px)" },
            paddingBottom: { xs: "10px", md: "80px" },
          }}
          className="no-scrollbar"
        >
          {/* Second Row - Task Overview Table */}
          <Grid sx={{ position: "relative" }}>
            <TaskOverviewTable
              selectedDate={selectedDate}
              handleDateChange={handleDateChange}
              taskOverviewData={taskOverviewData}
              isLoading={isEmployeeLoading}
            />
          </Grid>
          {/* Third Row - Celebrations & Absences */}
          <Grid container spacing={2} mt={2}>
            {/* Employee Celebrations */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Card
                sx={{
                  p: 2.5,
                  borderRadius: "16px",
                  height: "320px",
                  boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.05)',
                  border: '1px solid rgba(0,0,0,0.02)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Box>
                    <Typography sx={{ fontWeight: 800, fontSize: "16px", color: "#111827", letterSpacing: '-0.02em' }}>
                      Employee Celebrations
                    </Typography>
                    <Typography sx={{ color: "#6B7280", fontSize: "12px", mt: 0.3 }}>
                      Upcoming birthdays & anniversaries
                    </Typography>
                  </Box>
                  {upcomingCelebrations.length > 4 && who === true && (
                    <Button
                      onClick={() => navigate("/home/employee")}
                      sx={{
                        color: "#4F46E5",
                        fontSize: "13px",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        minWidth: 'auto',
                        '&:hover': { bgcolor: '#EEF2FF' }
                      }}
                      endIcon={<KeyboardArrowDownOutlinedIcon sx={{ fontSize: "18px" }} />}
                    >
                      See All
                    </Button>
                  )}
                </Box>

                {upcomingCelebrations.length > 0 ? (
                  <List
                    sx={{
                      p: 0,
                      flexGrow: 1,
                      overflow: upcomingCelebrations.length > 4 ? "auto" : "visible",
                    }}
                    className="no-scrollbar"
                  >
                    {upcomingCelebrations.map((celebration, index) => (
                      <ListItem
                        key={index}
                        sx={{
                          padding: 0,
                          py: 1.5,
                          borderBottom: index < upcomingCelebrations.length - 1 ? '1px solid #F3F4F6' : 'none',
                          '&:hover': {
                            bgcolor: '#F9FAFB',
                            borderRadius: '8px',
                            transition: 'all 0.2s ease'
                          }
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            overflow: "hidden",
                            mr: 2,
                            border: '2px solid #E5E7EB',
                            boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {renderFile(celebration?.file)}
                        </Avatar>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center', mb: 0.5 }}>
                              <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#111827" }}>
                                {celebration.name}
                              </Typography>
                              <Box
                                sx={{
                                  bgcolor: '#FEF3C7',
                                  color: '#92400E',
                                  px: 1.5,
                                  py: 0.3,
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: 600
                                }}
                              >
                                {celebration.date}
                              </Box>
                            </Box>
                          }
                          secondary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.3 }}>
                              <Typography sx={{ fontWeight: 500, fontSize: "13px", color: "#6B7280" }}>
                                {celebration.event}
                              </Typography>
                              <Typography sx={{ fontWeight: 400, fontSize: "12px", color: "#9CA3AF" }}>
                                {new Date(celebration.date).toLocaleString("en-US", { weekday: "long" })}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Stack alignItems={"center"} justifyContent="center" flexGrow={1}>
                    <img
                      src={Employee_Celebration_NoData}
                      alt="No Employee Celebration"
                      height={"87px"}
                      width={"87px"}
                    />
                    <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2, color: "#111827" }}>
                      No Upcoming Celebrations
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        padding: "0 40px",
                        mt: 1,
                        color: "#6B7280",
                        lineHeight: 1.6
                      }}
                    >
                      No special events coming up. Check back later to see the next set of celebrations!
                    </Typography>
                  </Stack>
                )}
              </Card>
            </Grid>

            {/* Upcoming Employee Absences */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Card
                sx={{
                  p: 2.5,
                  borderRadius: "16px",
                  height: "320px",
                  boxShadow: '0px 10px 30px rgba(7, 6, 6, 0.05)',
                  border: '1px solid rgba(0,0,0,0.02)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Box>
                    <Typography sx={{ fontWeight: 800, fontSize: "16px", color: "#111827", letterSpacing: '-0.02em' }}>
                      Upcoming Employee Absences
                    </Typography>
                    <Typography sx={{ color: "#6B7280", fontSize: "12px", mt: 0.3 }}>
                      Employees on leave soon
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => navigate("/home/leaveManagement")}
                    sx={{
                      color: "#4F46E5",
                      fontSize: "13px",
                      textTransform: "capitalize",
                      fontWeight: 600,
                      minWidth: 'auto',
                      '&:hover': { bgcolor: '#EEF2FF' }
                    }}
                    endIcon={<KeyboardArrowDownOutlinedIcon sx={{ fontSize: "18px" }} />}
                  >
                    See All
                  </Button>
                </Box>

                {futureLeavesGrouped2?.length > 0 ? (
                  <List
                    sx={{
                      p: 0,
                      flexGrow: 1,
                      overflow: "auto"
                    }}
                    className="no-scrollbar"
                  >
                    {futureLeavesGrouped2?.map((employeeLeave, index) => (
                      <ListItem
                        key={index}
                        sx={{
                          padding: 0,
                          py: 1.5,
                          borderBottom: index < futureLeavesGrouped2.length - 1 ? '1px solid #F3F4F6' : 'none',
                          '&:hover': {
                            bgcolor: '#F9FAFB',
                            borderRadius: '8px',
                            transition: 'all 0.2s ease'
                          }
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            overflow: "hidden",
                            mr: 2,
                            border: '2px solid #E5E7EB',
                            boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {renderFile(employeeLeave?.file)}
                        </Avatar>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center', mb: 0.5 }}>
                              <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#111827" }}>
                                {employeeLeave.name}
                              </Typography>
                              <Box
                                sx={{
                                  bgcolor: '#DBEAFE',
                                  color: '#1E40AF',
                                  px: 1.5,
                                  py: 0.3,
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: 600
                                }}
                              >
                                {new Date(employeeLeave.date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })}
                              </Box>
                            </Box>
                          }
                          secondary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.3 }}>
                              <Typography sx={{ fontWeight: 500, fontSize: "13px", color: "#6B7280", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>
                                {employeeLeave?.reason}
                              </Typography>
                              <Typography sx={{ fontWeight: 400, fontSize: "12px", color: "#9CA3AF" }}>
                                {new Date(employeeLeave.date).toLocaleString("en-US", { weekday: "long" })}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Stack alignItems={"center"} justifyContent="center" flexGrow={1}>
                    <img
                      src={Employee_Absence_NoData}
                      alt="No Employee Absence"
                      height={"87px"}
                      width={"87px"}
                    />
                    <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2, color: "#111827" }}>
                      No Upcoming Absences
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        padding: "0 40px",
                        mt: 1,
                        color: "#6B7280",
                        lineHeight: 1.6
                      }}
                    >
                      Great news! No employees are on leave for today, tomorrow, or the day after tomorrow.
                    </Typography>
                  </Stack>
                )}
              </Card>
            </Grid>
          </Grid>

          {/* App Download Card */}
          {/* <AppDownloadCard isAdmin={false} /> */}
        </Grid >

        {/* Right Section - 4 Columns */}
        < Grid
          size={{ xs: 12, sm: 12, md: 5, lg: 4 }}
          sx={{
            width: "100%",
            overflow: { xs: "visible", md: "scroll" },
            height: { xs: "auto", md: "calc(100vh - 170px)" },
            paddingBottom: "20px",
          }}
          className={`${Styles.rightGridAdmin} no-scrollbar`}
        >
          <Card className={Styles.rightSecondCard}>
            <Box className={Styles.calendarSection}>
              <Box className={Styles.calendarHeader}>
                <Typography
                  className={Styles.calendarMonth}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "space-around",
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <Button
                    sx={{ minWidth: 32 }}
                    onClick={() => setCalendarSelectedDate(calendarSelectedDate.subtract(1, 'month'))}
                  >
                    <ArrowBackIosNewIcon fontSize="small" sx={{ color: "black" }} />
                  </Button>
                  <span style={{ minWidth: 120, textAlign: 'center', fontWeight: 500 }}>
                    {calendarSelectedDate.format("MMMM YYYY")}
                  </span>
                  <Button
                    sx={{ minWidth: 32 }}
                    onClick={() => setCalendarSelectedDate(calendarSelectedDate.add(1, 'month'))}
                  >
                    <ArrowForwardIosIcon fontSize="small" sx={{ color: "black" }} />
                  </Button>
                </Typography>
              </Box>

              <Box className={Styles.weekDays}>
                {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                  (day) => (
                    <Typography key={day} className={Styles.weekDay}>
                      {day}
                    </Typography>
                  )
                )}
              </Box>

              {/* Calendar Grid */}
              <Box className={Styles.calendarGrid}>
                {(() => {
                  const currentDate = calendarSelectedDate.toDate();
                  const year = currentDate.getFullYear();
                  const month = currentDate.getMonth();
                  const firstDay = new Date(year, month, 1);
                  const lastDay = new Date(year, month + 1, 0);
                  const startingDayOfWeek = firstDay.getDay();
                  const daysFromPrevMonth = startingDayOfWeek;
                  const totalDays = lastDay.getDate();
                  const endingDayOfWeek = lastDay.getDay();
                  const daysFromNextMonth = 6 - endingDayOfWeek;
                  const days = [];
                  const prevMonthLastDay = new Date(year, month, 0).getDate();

                  for (let i = prevMonthLastDay - daysFromPrevMonth + 1; i <= prevMonthLastDay; i++) {
                    days.push({ date: new Date(year, month - 1, i), isCurrentMonth: false });
                  }

                  for (let i = 1; i <= totalDays; i++) {
                    const dateObj = new Date(year, month, i);
                    const isHoliday = allCalendarData.some((holiday) => {
                      const holidayDate = new Date(holiday.date);
                      return (
                        holidayDate.getDate() === dateObj.getDate() &&
                        holidayDate.getMonth() === dateObj.getMonth() &&
                        holidayDate.getFullYear() === dateObj.getFullYear()
                      );
                    });
                    const isToday = dayjs(dateObj).isSame(dayjs(), "day");
                    days.push({ date: dateObj, isCurrentMonth: true, isHoliday, isToday });
                  }

                  for (let i = 1; i <= daysFromNextMonth; i++) {
                    days.push({ date: new Date(year, month + 1, i), isCurrentMonth: false });
                  }

                  return days.map((day, index) => (
                    <Box
                      key={index}
                      className={`${Styles.calendarDay} ${day.isHoliday ? Styles.holidayDay : ""
                        } ${!day.isCurrentMonth ? Styles.otherMonthDay : ""}`}
                      sx={{
                        ...(day.isToday && {
                          backgroundColor: "#2B6AB1 !important",
                          borderRadius: "50% !important",
                          "& .MuiTypography-root": {
                            color: "white !important",
                          },
                        }),
                      }}
                    >
                      <Typography className={Styles.dayNumber}>
                        {day.date.getDate()}
                      </Typography>
                    </Box>
                  ));
                })()}
              </Box>
            </Box>

            {/* Holidays Carousel */}
            <Box
              className={Styles.holidaysCarousel}
              onMouseEnter={() => {
                if (swiperInstance) {
                  const upcomingIndex = Math.max(0, allCalendarData.findIndex(h => new Date(h.date) >= new Date().setHours(0, 0, 0, 0)));
                  swiperInstance.slideToLoop(upcomingIndex);
                  swiperInstance.autoplay.stop();
                }
              }}
              onMouseLeave={() => {
                if (swiperInstance) {
                  swiperInstance.autoplay.start();
                }
              }}
            >
              {allCalendarData.length > 0 ? (
                <Swiper
                  onSwiper={setSwiperInstance}
                  modules={[Pagination, Navigation, Mousewheel, Autoplay]}
                  direction="vertical"
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  pagination={false}
                  navigation={false}
                  loop={true}
                  mousewheel={true}
                  autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                    // pauseOnMouseEnter: true, // Handled manually
                  }}
                  initialSlide={Math.max(0, allCalendarData.findIndex(h => new Date(h.date) >= new Date().setHours(0, 0, 0, 0)))}
                  key={allCalendarData.length}
                  style={{ height: "55vh" }}
                >
                  {allCalendarData.map((holiday, index) => {
                    const date = new Date(holiday?.date);
                    const day = date.getDate();
                    const suffix = getDaySuffix(day);
                    const formattedDate = `${day}${suffix} ${date.toLocaleDateString(
                      "en-US",
                      { month: "short" }
                    )}, ${date.getFullYear()}`;
                    const dayName = date.toLocaleString("en-US", {
                      weekday: "long",
                    });

                    // Check if holiday is past
                    const isPast = dayjs(holiday.date).isBefore(dayjs(), 'day');

                    return (
                      <SwiperSlide key={index}>
                        <Box
                          sx={{
                            background: "#F4F8FF",
                            padding: "10px",
                            borderRadius: "8px",
                            opacity: isPast ? 0.5 : 1, // Dim past holidays
                            filter: isPast ? "grayscale(100%)" : "none", // Optional: Grayscale past holidays
                            transition: "all 0.3s ease",
                          }}
                        >
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                            alignItems={"flex-start"}
                            spacing={2}
                          >
                            <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
                              <Typography
                                className={Styles.leaveheader}
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                {holiday?.name}
                              </Typography>
                              <Typography
                                className={Styles.leaveSubheader}
                                sx={{
                                  fontSize: "12px",
                                  color: "text.secondary",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  lineHeight: 1.2
                                }}
                              >
                                {holiday?.description}
                              </Typography>
                            </Stack>
                            <Stack spacing={0.5} alignItems="flex-end" sx={{ flexShrink: 0 }}>
                              <Typography
                                className={Styles.leaveheader}
                                sx={{ fontWeight: 600, fontSize: "14px", whiteSpace: "nowrap" }}
                              >
                                {formattedDate}
                              </Typography>
                              <Typography
                                className={Styles.leaveSubheader}
                                sx={{ fontSize: "12px", color: "text.secondary" }}
                              >
                                {dayName}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Box>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              ) : (
                <Stack alignItems={"center"} mt={3}>
                  <img
                    src={PublicHoliday_NoData}
                    alt="No Public Holiday"
                    height={"87px"}
                    width={"87px"}
                  />
                  <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2 }}>
                    No Upcoming Holidays
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      textAlign: "center",
                      padding: "0 50px",
                      mt: 1,
                    }}
                  >
                    No public holidays to show for this month and the next.
                  </Typography>
                </Stack>
              )}
            </Box>
          </Card>
        </Grid >
      </Grid >
    </Box >
  );
};

export default EmployeeDashboard;